import React from "react";
import AlertaTemporario from "../AlertaTemporario";
import AlertaSection, {
  TextoAlerta,
} from "./AlertaSorteiosCapitalizacao.Style";
import { Text } from "../common";

const AlertaSorteiosCapitalizacao = () => {
  return (
    <AlertaSection
      as={AlertaTemporario}
      startIn="2022-04-14"
      stopIn="2022-04-20 23:59:59"
      sectionName="Alerta sorteio capitalização"
    >
      <TextoAlerta as={Text}>
        Aviso: devido ao feriado desta sexta-feira, dia 15/04, os sorteios do
        SuperXcap (planos 503, 504 e 505) serão realizados na segunda, dia
        18/04.
      </TextoAlerta>
    </AlertaSection>
  );
};

AlertaSorteiosCapitalizacao.defaultProps = {};

AlertaSorteiosCapitalizacao.propTypes = {};

export default AlertaSorteiosCapitalizacao;
